import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "./../../Apiurls/Apiurls";
import { AuthContext } from "./../../Contextapi/ContextApi";
import "./AddEmployee.css";
import Navbar from "../../Shared/Navbar";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function AddEditEmployee() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const { logout } = useContext(AuthContext);
    const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    address: "",
    role: "",
    password: "",  // ⭐ Added password
  });

  useEffect(() => {
    if (isEdit) {
      const fetchData = async () => {
        try {
          const res = await axios.get(`${baseUrl}/api/employees/${id}`);
          setFormData({
            ...res.data,
            password: "",  // ⭐ Do not load existing password
          });
        } catch (err) {
          console.error("Failed to load employee:", err);
          alert("Failed to load employee details");
        }
      };
      fetchData();
    }
  }, [id, isEdit]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    if (isEdit) {
      await axios.put(`${baseUrl}/api/employees/${id}`, formData);
      alert("Employee updated successfully");
    } else {
      await axios.post(`${baseUrl}/api/employees`, formData);
      alert("Employee registered successfully");
    }

    navigate("/Viewemployee");
  } catch (err) {
    if (err.response && err.response.data.message === "Email already exists") {
      alert("❌ Email already exists. Use a different email.");
    } else {
      alert("Failed to save employee");
    }
  }
};


  return (
    <div className="addemployee-container-fluid">
      <div className="addemployee-row">

        <div className="col-md-2">
          <Navbar />
        </div>

        <div className="addemployee-main col-md-10 d-flex justify-content-center align-items-center vh-100">
          <div className="addemployee-card card shadow-sm">
            <div className="card-body">
              <h5 className="addemployee-title text-center mb-4 fw-bold">
                {isEdit ? "Edit Employee" : "Add Employee"}
              </h5>

              <form onSubmit={handleSubmit} className="addemployee-form mx-auto">

                <div className="mb-3">
                  <label className="form-label fw-bold">Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" required />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Email</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" required />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Mobile</label>
                  <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} className="form-control" required />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Address</label>
                  <textarea name="address" value={formData.address} onChange={handleChange} className="form-control" required />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-bold">Role</label>
                  <select name="role" value={formData.role} onChange={handleChange} className="form-control" required>
                    <option value="">Select Role</option>
                    <option value="Intern">Intern</option>
                    <option value="Employee">Employee</option>
                    {/* <option value="Admin">Admin</option> */}
                  </select>
                </div>

                {/* ⭐ PASSWORD FIELD */}
               <div className="mb-3 position-relative">
  <label className="form-label fw-bold">
    Password {isEdit ? "(Leave empty to keep same)" : ""}
  </label>

  <div className="input-group">
    <input
      type={showPassword ? "text" : "password"}
      name="password"
      value={formData.password}
      onChange={handleChange}
      className="form-control"
      required={!isEdit}
    />

    <span
      className="input-group-text"
      style={{ cursor: "pointer" }}
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <FaEyeSlash /> : <FaEye />}
    </span>
  </div>
</div>


                <button type="submit" className="btn btn-primary w-100">
                  {isEdit ? "Update Employee" : "Register Employee"}
                </button>

              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default AddEditEmployee;
